import { AxiosRequestConfig } from 'axios';
import { format } from 'date-fns';
import API from 'services/api.js';
import { URL_LONG_TERM_DATA } from 'services/urls.js';

export type LTDRow = { eid: string; visId?: string } & {
	[date: string]: number;
};

export const actionFetchLongTermData = (
	timePeriod: string,
	dateFrom: Date,
	dateTo: Date,
	sessionId: number,
	eid: string,
	showMessage: (msg: string) => void
): Promise<{ xTabFields: string[]; xTabData: LTDRow[] } | null> => {
	const params = {
		params: {
			sessionId: sessionId,
			timePeriod: timePeriod,
			dateFrom: format(dateFrom, 'yyyy-MM-dd'),
			dateTo: format(dateTo, 'yyyy-MM-dd'),
			eid: eid,
		},
		headers: {
			'x-opw-format': 'xtab',
		},
	};
	return API.get(URL_LONG_TERM_DATA, params)
		.then((response) => {
			if ('xTabFields' in response.data) return response.data;
			return null;
		})
		.catch((error) => {
			showMessage('Err fetching session average data: ' + error);
			return null;
		});
};

export const getDownloadFile = async (
	timePeriod: string,
	dateFrom: Date,
	dateTo: Date,
	sessionId: number,
	eid: string
): Promise<string | null> => {
	const params: AxiosRequestConfig = {
		params: {
			sessionId: sessionId,
			timePeriod: timePeriod,
			dateFrom: dateFrom,
			dateTo: dateTo,
			eid: eid,
		},
		responseType: 'blob',
		timeout: 30000,
		headers: {
			'x-opw-format': 'csv',
		},
	};
	return API.get(URL_LONG_TERM_DATA, params)
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			//showMessage('Err getDownloadFile: ' + error)
			return null;
		});
};
